/** Presentation only. Keep existing API, cookie and storage namespaces compatible. */
export const BUILDY = {
  name: "Buildy",
  description: "Your website, thoughtfully built",
  robot: "/buildy-robot.webp",
  icon: "/buildy-favicon.png?v=d6562f7f5f",
} as const;
